/* used in a shop directory to set up the 3 col product list per category etc */

import React, { Component } from 'react'
import styled from 'styled-components'
import { graphql, StaticQuery } from 'gatsby'
import ProductGrid3Col from '../product_grid_3_col'
import GemFilter from '../gem_filter'
import MobileTitle from '../mobile_title';

const ProductListContainer = styled.div`
  padding-top: 60px;
  padding-bottom: 60px;
`

const hidden = [
  'Hidden on /shop'
]
class ProductListManualCollection extends Component {

  constructor(props) {
    super(props);
    this.state = { gemFilter: false };
    this.toggleGemFilter = this.toggleGemFilter.bind(this);
  }

  toggleGemFilter(gem) {
    if(this.state.gemFilter !== gem) {
      this.setState({gemFilter: gem});
    } else {
      this.setState({gemFilter: false});
    }
  }

  render() {

    let allGems = [];
    let uniqueGems = [];
    let gemFilter = false;

    const { category } = this.props;

    return (
        <StaticQuery
          query={graphql`
          query ProductListingManualCollectionQuery {
            collections:
            allShopifyCollection {
              edges {
                node {
                  id
                  descriptionHtml
                  title
                  handle
                  products {
                    id
                    handle
                    title
                    tags
                    variants {
                      shopifyId
                      title
                      sku
                      price
                      compareAtPrice
                      availableForSale
                    }
                    images {
                      id
                      localFile {
                        childImageSharp {
                          fluid(maxWidth: 910) {
                            ...GatsbyImageSharpFluid_withWebp
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          `}
          render={({ collections }) => (
            <>
              <MobileTitle title={category} />
                <GemFilter collections={collections} category={category} gemFilter={this.state.gemFilter} toggleGemFilter={this.toggleGemFilter}>
                {collections.edges
                  .filter(({ node: collection }) => collection.handle.toLowerCase() === category.toLowerCase())
                  .map(({ node: collection }) => (
                      collection.products.map((product, index) => {
                        return(
                          <ProductGrid3Col key={product.id} gemFilter={this.state.gemFilter} product={product} hidden={hidden} />
                        )
                      })
                    )
                  )
                }
              </GemFilter>
            </>
          )}
        />
    );
  }
}

// .filter(({ node: product }) => product.availableForSale === true)

export default ProductListManualCollection;
